// extracted by mini-css-extract-plugin
export default {"message":"ThankYouPage_message__RYjXi"};